var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlltransaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4802_1245)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.83398,
    y: 2.5,
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.042 29.2923C25.135 29.3852 25.2088 29.4955 25.2591 29.6169C25.3094 29.7383 25.3353 29.8684 25.3353 29.9998C25.3353 30.1312 25.3094 30.2614 25.2591 30.3828C25.2088 30.5042 25.135 30.6144 25.042 30.7073L21.042 34.7073C20.9492 34.8003 20.8389 34.874 20.7175 34.9244C20.5961 34.9747 20.466 35.0006 20.3345 35.0006C20.2031 35.0006 20.073 34.9747 19.9516 34.9244C19.8302 34.874 19.7199 34.8003 19.627 34.7073L15.627 30.7073C15.5341 30.6144 15.4604 30.5041 15.4101 30.3827C15.3599 30.2613 15.334 30.1312 15.334 29.9998C15.334 29.8684 15.3599 29.7383 15.4101 29.6169C15.4604 29.4955 15.5341 29.3852 15.627 29.2923C15.8147 29.1047 16.0692 28.9993 16.3345 28.9993C16.4659 28.9993 16.596 29.0251 16.7174 29.0754C16.8388 29.1257 16.9491 29.1994 17.042 29.2923L19.3345 31.5861V13.9998C19.3345 13.7346 19.4399 13.4802 19.6274 13.2927C19.815 13.1052 20.0693 12.9998 20.3345 12.9998C20.5998 12.9998 20.8541 13.1052 21.0416 13.2927C21.2292 13.4802 21.3345 13.7346 21.3345 13.9998V31.5861L23.627 29.2923C23.7199 29.1993 23.8302 29.1256 23.9516 29.0752C24.073 29.0249 24.2031 28.999 24.3345 28.999C24.466 28.999 24.5961 29.0249 24.7175 29.0752C24.8389 29.1256 24.9492 29.1993 25.042 29.2923ZM37.042 17.2923L33.042 13.2923C32.9492 13.1993 32.8389 13.1256 32.7175 13.0753C32.5961 13.0249 32.466 12.999 32.3345 12.999C32.2031 12.999 32.073 13.0249 31.9516 13.0753C31.8302 13.1256 31.7199 13.1993 31.627 13.2923L27.627 17.2923C27.4394 17.48 27.334 17.7344 27.334 17.9998C27.334 18.2652 27.4394 18.5197 27.627 18.7073C27.8147 18.895 28.0692 19.0004 28.3345 19.0004C28.5999 19.0004 28.8544 18.895 29.042 18.7073L31.3345 16.4136V33.9998C31.3345 34.265 31.4399 34.5194 31.6274 34.7069C31.815 34.8945 32.0693 34.9998 32.3345 34.9998C32.5998 34.9998 32.8541 34.8945 33.0416 34.7069C33.2292 34.5194 33.3345 34.265 33.3345 33.9998V16.4136L35.627 18.7073C35.8147 18.895 36.0692 19.0004 36.3345 19.0004C36.5999 19.0004 36.8544 18.895 37.042 18.7073C37.2297 18.5197 37.3351 18.2652 37.3351 17.9998C37.3351 17.7344 37.2297 17.48 37.042 17.2923Z",
    fill: "#FE996C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4802_1245",
    x: 0.833984,
    y: 0.5,
    width: 51,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4802_1245"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4802_1245",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlltransaction);
export default __webpack_public_path__ + "static/media/All transaction.4fe3df3434545a150faa580c2a24fb3e.svg";
export { ForwardRef as ReactComponent };